import { createKeyedDataAsyncSlice } from '../../createKeyedDataAsyncSlice';
import { postClientCancelOrderByIDAsync } from '../../../API/clientPortal/clientOrderAPI';

export const { slice: postClientOrderCancellationSlice, asyncAction: postClientOrderCancellationAction } =
  createKeyedDataAsyncSlice(
    'postClientOrderCancellationStatus',
    postClientCancelOrderByIDAsync,
    ({ orderId }) => `${orderId}`
  );
